<template>
  <section class="bloc-image-wide scroll-step js-scroll-show">
    <img class="bloc-image-wide__img" :src="require(`@/${content.img}`)">
  </section>
</template>

<script>
export default {
  name: 'ImageWide',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-image-wide {
    width: 100vw;
    background: $th-white;

    &__img {
      width: 100%;
      height: grid(8.15, 7);
      object-fit: cover;
      display: block;
      position: relative;
      margin: 0 auto;
    }
  }
</style>
